import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M24 20C24 20.5525 23.5525 21 23 21H1C0.4475 21 0 20.5525 0 20V4C0 3.4475 0.4475 3 1 3H23C23.5525 3 24 3.4475 24 4V20Z',
                    fill: '#D82827',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M16.1803 10.5204H13.2348L11.9998 7.84192L10.7633 10.5204H7.81885L9.97035 12.7469L9.17535 15.9734L11.9998 14.3689L14.8238 15.9734L14.0288 12.7469L16.1803 10.5204Z',
                    fill: '#FFFD38',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const VietnamColored = React.forwardRef(IconComponent);
VietnamColored.displayName = 'VietnamColored';

export { VietnamColored };
